export const UserConstants = {
  clientUserRole: 0,
  auditUserRole: 1,
  practiceUserRole: 200
};
